export default {
  over12: {
    description: `Vi kan dessvärre inte hjälpa er eftersom denna tjänst riktar sig till barn t.o.m. 12 år.

Om du är osäker på vart ni bör vända er, ring 1177 för vägledning. De vet hur barn- och ungdomspsykiatrin är organiserad där ni bor.
      `,
  },
};
